import { makeObservable, observable } from 'mobx'

class LeaveStore {
  hoveredLeaveId: string | null | undefined

  constructor() {
    makeObservable(this, {
      hoveredLeaveId: observable,
    })
  }
}

export default LeaveStore
